// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__CmDMi","savePackageButton":"ClientWallet_savePackageButton__H-5p9"};